module.exports = __webpack_public_path__ + "img/features_2.ba867a33.png";